import { Box, Typography } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import InitiativeCard from '../common/InitiativeCard'
import { leadershipInitiatives } from '../../data/leadershipContent'
import { MOBILE_MQ, mobilePaddingX, mobileSectionTitleSx } from '../../theme/mobileLayout'
import { scale } from '../../theme/scale'
import { SLIDER_TRANSITION_SPEED_COMPACT } from '../../theme/slider'
import 'swiper/css'

const SLIDE_WIDTH = 440
const SLIDE_GAP = 40

export default function LeadershipInitiativesSection() {
  const slides = [...leadershipInitiatives, ...leadershipInitiatives]

  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        pl: mobilePaddingX,
        pr: 0,
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      <Typography
        component="h2"
        sx={{
          ...mobileSectionTitleSx,
          fontSize: { ...mobileSectionTitleSx.fontSize, lg: scale.fontSize.sectionTitle },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          mb: { xs: 5, md: 8, lg: '80px' },
          maxWidth: 1520,
          pr: mobilePaddingX,
          boxSizing: 'border-box',
          [MOBILE_MQ]: { fontSize: 28 },
        }}
      >
        Other Key Initiatives
      </Typography>

      <Box
        sx={{
          display: 'none',
          [MOBILE_MQ]: { display: 'flex' },
          flexDirection: 'column',
          gap: '20px',
          pr: mobilePaddingX,
          boxSizing: 'border-box',
        }}
      >
        {leadershipInitiatives.map((item) => (
          <InitiativeCard key={item.title} {...item} />
        ))}
      </Box>

      <Box
        sx={{
          display: 'block',
          [MOBILE_MQ]: { display: 'none' },
          width: {
            xs: 'calc(100vw - 40px)',
            sm: 'calc(100vw - 48px)',
            md: 'calc(100vw - 80px)',
            lg: 'calc(100vw - 160px)',
            xl: 'calc(100vw - 400px)',
          },
          maxWidth: 'none',
          overflow: 'hidden',
          '& .swiper': { overflow: 'visible', width: '100%' },
          '& .swiper-slide': {
            width: {
              xs: 'min(320px, calc(100vw - 80px)) !important',
              sm: '360px !important',
              lg: `${SLIDE_WIDTH}px !important`,
            },
            height: 'auto',
            flexShrink: 0,
          },
        }}
      >
        <Swiper
          modules={[Autoplay]}
          slidesPerView="auto"
          spaceBetween={SLIDE_GAP}
          loop
          loopAdditionalSlides={leadershipInitiatives.length}
          loopPreventsSliding={false}
          observer
          observeParents
          resizeObserver
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={SLIDER_TRANSITION_SPEED_COMPACT}
          grabCursor
          breakpoints={{
            0: { spaceBetween: 24 },
            900: { spaceBetween: SLIDE_GAP },
          }}
        >
          {slides.map((item, index) => (
            <SwiperSlide key={`${item.title}-${index}`}>
              <InitiativeCard {...item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  )
}
